import {Pipe, PipeTransform} from '@angular/core';
import {AddSpacesPipe} from '../addSpaces/addSpaces.pipe';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {
  constructor(private addSpacesPipe: AddSpacesPipe) {}

  transform(value: string = '') {
    if (value?.length === 4 || value?.length === 7 || value?.length === 8) {
      return this.addSpacesPipe.transform(value, 4);
    } else if ((value?.length === 11 || value?.length === 12) && value[0] === '+') {
      const countryCode = value.slice(0, 4);
      const phoneNumber = this.addSpacesPipe.transform(value.slice(4), 4);
      return countryCode + ' ' + phoneNumber;
    } else {
      return value;
    }
  }
}
